import gql from "graphql-tag";

const GET_WARD = gql`
    query GetWards($site: ID!, $page: Int, $limit: Int) {
        GetWards(site: $site, page: $page, limit: $limit) {
            docs {
                id
                name
                description
                rooms {
                    id
                    name
                    description
                    created_at
                    beds {
                        id
                        name
                        description
                        created_at
                        taken
                    }
                }
                created_at
            }
        }
    }
`;

const NEW_WARD = gql`
    mutation CreateWard($name: String!, $site: ID!, $desc: String!) {
        NewWard(name: $name, site: $site, desc: $desc) {
            message
            doc {
                id
                name
                description
                rooms {
                    id
                    name
                    description
                    created_at
                    beds {
                        id
                        name
                        description
                        created_at
                    }
                }
                created_at
            }
        }
    }
`;

//  New room
const NEW_ROOM = gql`
    mutation NewRoom($name: String!, $desc: String!, $ward: ID!) {
        NewRoom(name: $name, ward: $ward, desc: $desc) {
            message
            doc {
                id
                name
                description
                created_at
                beds {
                    id
                    name
                    description
                    created_at
                }
            }
        }
    }
`;

// New bed
const NEW_BED = gql`
    mutation NewBed($name: String!, $desc: String!, $room: ID!) {
        NewBed(name: $name, room: $room, desc: $desc) {
            message
            doc {
                id
                name
                description
                created_at
            }
        }
    }
`;

export const GET_WARDS_PATIENT = gql`
    query GetWardsForPatient($site: ID!) {
        GetWards(site: $site, page: 1, limit: 100) {
            docs {
                id
                name
            }
        }
    }
`;

export { GET_WARD, NEW_WARD, NEW_ROOM, NEW_BED };
